<template>
    <div>
      <v-select
          placeholder="Choose device to lock"
          class="w-100 mb-1"
          :clearable="false"
          :appendToBody="true"
          :value="deviceToLock"
          @input="deviceToLockValue = $event.value"
          :options="profilesAndDevices.deviceList"
          :selectable="device => !device.disabled"
          :searchable="false"
      >
        <template slot="open-indicator">
          <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
          </svg>
        </template>
      </v-select>
      <v-select
          placeholder="Choose profile to lock"
          class="w-100 mb-1"
          :clearable="false"
          :appendToBody="true"
          :value="profileToLock"
          @input="profileToLockValue = $event.value"
          :options="profilesAndDevices.profilesList"
          :selectable="profile => !profile.disabled"
          :searchable="false"
      >
        <template slot="open-indicator">
          <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
          </svg>
        </template>
      </v-select>
      <div v-if="createKidModeError" class="-error">
        {{$lang.messages.start_kids_mode_error}}
      </div>
      <div class="text-center mt-1 mb-1">
        <button class="btn btn-main -shadow" @click="startKidsMode">
          {{$lang.messages.start_kids_mode}}
        </button>
      </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "LockDeviceWithProfile",
  props: ['defaultDevice', 'defaultProfile'],
  data: function (){
    return {
      createKidModeError: false,
      deviceToLockValue: this.defaultDevice || null,
      profileToLockValue: this.defaultProfile || null
    }
  },
  computed: {
    ...mapState({
      settings: state => state.accountData,
      currentDeviceID: state => state.currentDeviceID,
    }),
    profilesAndDevices() {
      const deviceList = [];
      const activeProfilesId = [];
      const profilesList = [];

      Object.keys(this.settings.devices).forEach((deviceId) => {
        const device = {
          value: deviceId,
          label: this.settings.devices[deviceId].name,
          disabled: true,
        };

        if (!this.settings.devices[deviceId].locked) {
          device.disabled = false;
        } else if (this.settings.devices[deviceId].currentProfileID) {
          activeProfilesId.push(this.settings.devices[deviceId].currentProfileID)
        }

        if (this.settings.isPremium || this.currentDeviceID === device.value) {
          deviceList.push(device);
        }
      })

      Object.keys(this.settings.profiles).forEach((profileId) => {
          profilesList.push( {
            value: profileId,
            label: this.settings.profiles[profileId].kidName,
            disabled: activeProfilesId.includes(profileId),
          })
      })

      return {deviceList, profilesList, activeProfilesId};
    },
    profilesList() {
      return Object.keys(this.settings.profiles).map((profileId) => {
        return {
          value: profileId,
          label: this.settings.profiles[profileId].kidName
        }
      })
    },
    deviceList() {
      return Object.keys(this.settings.devices).map((deviceId) => {
        return {
          value: deviceId,
          label: this.settings.devices[deviceId].name
        }
      })
    },
    profileToLock() {
      if (this.profileToLockValue) {
        return this.profilesList.find(item => item.value === this.profileToLockValue);
      }
      return null;
    },
    deviceToLock(){
      if (this.deviceToLockValue) {
        return this.deviceList.find(item => item.value === this.deviceToLockValue);
      }
      return null;
    }
  },
  methods: {
    startKidsMode () {
      if (!this.deviceToLockValue || !this.profileToLockValue || this.profilesAndDevices.activeProfilesId.includes(this.profileToLockValue)) {
        this.createKidModeError = true;
      } else {
        this.$emit('startkidsmode', this.profileToLockValue, this.deviceToLockValue)
      }
    }
  }
}
</script>